import { FEED_STATE_TO_DISPLAY_STATUS_MAP } from "@constants/marketing-feeds.constants";

export const generateMarketFeedStatusForToken = (status: string) => {
  return FEED_STATE_TO_DISPLAY_STATUS_MAP.find((singleItem) => {
    if (singleItem.state.toLowerCase() === status.toLowerCase()) {
      return true;
    } else return false;
  });
};
